import { TranslationMap } from '@trimble-gcs/i18n-types';

export function propertiesTranslations() {
  return {
    saveError: {
      text: $localize`:@@singleSelectedProperties.saveError:Error saving changes. Please try again later.`,
      desc: 'Error message when trying to save the point cloud properties.',
    },
    status: {
      text: $localize`:@@singleSelectedProperties.status:Status`,
      desc: 'Status label for the point cloud properties.',
    },
    captureDate: {
      text: $localize`:@@singleSelectedProperties.captureDate:Capture Date`,
      desc: 'Label for the capture date of the point cloud',
    },
    uploadedBy: {
      text: $localize`:@@singleSelectedProperties.uploadedBy:Uploaded By`,
      desc: 'Label for the person who uploaded the point cloud',
    },
    uploadedDate: {
      text: $localize`:@@singleSelectedProperties.uploadedDate:Upload Date`,
      desc: 'Label for the upload date of the point cloud',
    },
    scannerType: {
      text: $localize`:@@singleSelectedProperties.scannerType:Scanner Type`,
      desc: 'Label for the type of scanner used',
    },
    numberOfStations: {
      text: $localize`:@@singleSelectedProperties.numberOfStations:# of Stations`,
      desc: 'Label for the number of stations',
    },
    pointCloudName: {
      text: $localize`:@@singleSelectedProperties.pointCloudName:Point Cloud Name`,
      desc: 'Label for the name of the point cloud',
    },
    pointCount: {
      text: $localize`:@@singleSelectedProperties.pointCount:Point Count`,
      desc: 'Label for the number of points in the point cloud',
    },
    isClassified: {
      text: $localize`:@@singleSelectedProperties.isClassified:Classified`,
      desc: 'Label indicating if the point cloud is classified',
    },
    area: {
      text: $localize`:@@singleSelectedProperties.area:Point Cloud Area`,
      desc: 'Label for the area of the point cloud',
    },
    location: {
      text: $localize`:@@singleSelectedProperties.location:Point Cloud Location`,
      desc: 'Label for the location of the point cloud',
    },
    fileSize: {
      text: $localize`:@@singleSelectedProperties.fileSize:Size`,
      desc: 'Label for the file size of the point cloud',
    },
    notes: {
      text: $localize`:@@singleSelectedProperties.notes:Notes`,
      desc: 'Label for the notes associated with the point cloud',
    },
    tags: {
      text: $localize`:@@singleSelectedProperties.tags:Tags`,
      desc: 'Label for the tags associated with the point cloud',
    },
  } satisfies TranslationMap;
}
